'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import WorldPageSkeleton from '@/app/[locale]/(worlds)/[roomId]/loading';

// The URL already navigated to; a remount before the document unloads must not restart the request
// (the app router guards its own full navigation the same way, `pendingMpaPath`).
let pendingHref: string | undefined;
if (typeof window !== 'undefined') {
  // A page restored from the back/forward cache may need to navigate again.
  window.addEventListener('pageshow', event => {
    if (event.persisted) pendingHref = undefined;
  });
}
type DocumentNavigationProps = {
  href: string;
};

/**
 * Replaces the current client navigation with a full document navigation to `href`, so the room gets a
 * document with its own isolation headers, and shows the room loading skeleton until it loads
 * (CONNECT-6329). It runs after the commit, when the router has already written `href` to the history
 * entry, and replaces that entry, so Back returns to the previous room once.
 */
export default function DocumentNavigation(t0) {
  const $ = _c(4);
  const {
    href
  } = t0;
  let t1;
  let t2;
  if ($[0] !== href) {
    t1 = () => {
      if (pendingHref === href) {
        return;
      }
      pendingHref = href;
      location.replace(href);
    };
    t2 = [href];
    $[0] = href;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <WorldPageSkeleton />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}